import { avatarColor, avatarInitials, type AppSessionUser } from '@overlayqa/shared';

/** Use the same normalized person as ProjectCard, including discarded letter images. */
export function accountAvatarAppearance(user?: AppSessionUser) {
  if (!user) return {};
  const palette = avatarColor(user.id);
  const avatar = {
    borderRadius: '50%',
    flexShrink: 0,
    // Outrank index.css's two-class popover selector as well as its !important.
    '&&&': { backgroundColor: `${user.avatarUrl ? 'transparent' : palette.tint} !important` },
    ...(user.avatarUrl ? {} : {
      position: 'relative',
      '& img': { visibility: 'hidden' },
      '&::after': {
        content: JSON.stringify(avatarInitials(user.name)),
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: palette.ink,
        fontFamily: 'inherit',
        fontWeight: 500,
        lineHeight: 1,
      },
    }),
  };
  return {
    userButtonAvatarBox: { ...avatar, width: '40px', height: '40px', fontSize: '14px' },
    userPreviewAvatarBox: { ...avatar, fontSize: '12px' },
  };
}
